import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '320px',
    marginTop: 140,
    marginBottom: 140,
    background: theme.palette.background.default,
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '48px',
    textAlign: 'left',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      marginBottom: '40px',
    },
  },

  headerContent: {
    alignSelf: 'flex-start',

    [theme.breakpoints.down('sm')]: {
      alignSelf: 'center',
      width: '100%',
    },
  },

  description: {
    fontFamily: 'MontserratRegular',
    alignSelf: 'flex-end',
    maxWidth: '400px',
    margin: 0,

    fontSize: '16px',
    textAlign: 'right',

    [theme.breakpoints.down('sm')]: {
      alignSelf: 'center',
      maxWidth: '100%',
      marginTop: '20px',
      textAlign: 'center',
    },
  },

  eyebrow: {
    display: 'block',
    marginBottom: '12px',

    fontFamily: 'MontserratSemiBold',
    fontSize: '14px',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    lineHeight: 1.2,

    color: '#65CDBF',
  },

  title: {
    margin: 0,

    fontFamily: 'MontserratBold',
    fontSize: '44px',

    color: theme.palette.text.primary,

    [theme.breakpoints.down('md')]: {
      fontSize: '36px',
    },
  },

  cards: {
    justifyContent: 'center',
  },

  cardItem: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useStyles;
